import { api } from "../../lib";
import type { FragmentCountQualifier } from "../../utils/fragmentCount";

export interface GrossCode {
  id: string;
  code: string;
  description: string;
  isActive: boolean;
  fragmentCount?: number | null;
  fragmentCountQualifier?: FragmentCountQualifier | null;
  createdAt: string;
  updatedAt: string;
}

export interface CreateGrossCodeInput {
  code: string;
  description: string;
  isActive?: boolean;
  fragmentCount?: number | null;
  fragmentCountQualifier?: FragmentCountQualifier | null;
}

export interface UpdateGrossCodeInput extends Partial<CreateGrossCodeInput> {
  id: string;
}

export const grossCodesService = {
  getAll: async () => {
    return api.get<GrossCode[]>("/admin/accessioning-gross-codes");
  },

  getById: async (id: string) => {
    return api.get<GrossCode>(`/admin/accessioning-gross-codes/${id}`);
  },

  create: async (input: CreateGrossCodeInput) => {
    return api.post<GrossCode>("/admin/accessioning-gross-codes", input);
  },

  update: async (input: UpdateGrossCodeInput) => {
    const { id, ...updates } = input;
    return api.put<GrossCode>(`/admin/accessioning-gross-codes/${id}`, updates);
  },

  toggleActive: async (id: string, isActive: boolean) => {
    return api.put<GrossCode>(`/admin/accessioning-gross-codes/${id}`, {
      isActive,
    });
  },

  delete: async (id: string) => {
    await api.delete<void>(`/admin/accessioning-gross-codes/${id}`);
  },
};
